var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid app-container"},[_c('router-view',{on:{"showLanguage":_vm.showLanguage}})],1),_c('language',{ref:"languageRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }